import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import ShortInfo from './../block/ShortInfo'
import MoskitnieSistemySlyder from './../block/MoskitnieSistemySlyder'
import MoskitnieSistemySlyder2 from './../block/MoskitnieSistemySlyder2'
import PhotoGallarySlyder from './../block/PhotoGallarySlyder'
import PosmotriteVideo from './../block/PosmotriteVideo'
import MoskitnieSistemyPreimushestva from './../block/MoskitnieSistemyPreimushestva'
import Raschet from './../block/Raschet'
import Kontakti from './../block/Kontakti'


class MoskitnieSistemy extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
        />
        <ShortInfo
          data={data?.short_info || {}}
          assets_path={assets_path}
        />
        <MoskitnieSistemySlyder
          data={data?.moskitniesistemyslyder1 || {}}
        />
        <MoskitnieSistemySlyder2
          data={data?.moskitniesistemyslyder2 || {}}
        />
        <PhotoGallarySlyder
          data={data?.photogallary || {}}
        />
        <PosmotriteVideo
          data={data?.videos || {}}
          assets_path={assets_path}
          margin={`bottom`}
        />
        <MoskitnieSistemyPreimushestva
          title={data?.preimlesnic?.title || ``}
          rtext={data?.preimlesnic?.rtext || ``}
          text={data?.preimlesnic?.text || ``}
          list={data?.preimlesnic?.list || []}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
      </>
    )
  }
}

MoskitnieSistemy.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

MoskitnieSistemy.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default MoskitnieSistemy